var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.721 2.27911C14.6493 2.20775 14.5587 2.15834 14.4599 2.13669C14.3611 2.11505 14.2581 2.12207 14.1632 2.15692L2.47566 6.40692C2.37486 6.44515 2.28808 6.51314 2.22685 6.60186C2.16561 6.69059 2.13281 6.79584 2.13281 6.90364C2.13281 7.01144 2.16561 7.11669 2.22685 7.20541C2.28808 7.29413 2.37486 7.36213 2.47566 7.40036L7.57566 9.44036L9.61566 14.5404C9.65398 14.6367 9.71968 14.7198 9.80464 14.7792C9.8896 14.8387 9.99012 14.872 10.0938 14.875C10.2011 14.8728 10.3053 14.8382 10.3926 14.7756C10.4798 14.713 10.546 14.6254 10.5825 14.5244L14.8325 2.83692C14.8687 2.74293 14.8775 2.64059 14.8577 2.54182C14.838 2.44306 14.7905 2.35195 14.721 2.27911ZM10.0938 12.8563L8.61159 9.13754L11.1563 6.59286L10.4072 5.8438L7.84128 8.40973L4.14378 6.90629L13.4566 3.54348L10.0938 12.8563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic-send.87040e78c5846b29bd272a366cbfef21.svg";
export { ForwardRef as ReactComponent };